import "./NotFound.css";

const NotFound = () => {
    return (
        <>
            <div className="not_found_page">
                <h1>404</h1>
                <h2 className="coming_soon">STRÁNKA NENALEZENA</h2>
            </div>
        </>
    );
};

export default NotFound;
